import { useMemo } from "react"
import {
  IconButton,
  IconButtonProps,
  TabScrollButtonProps,
  useTheme,
} from "@mui/material"
import { getIcon } from "utils/icon"
import ArrowBackIosRoundedIcon from "@mui/icons-material/ArrowBackIosRounded"
import ArrowForwardIosRoundedIcon from "@mui/icons-material/ArrowForwardIosRounded"

export type ScrollableIconButtonProps = Pick<
  TabScrollButtonProps,
  "direction"
> &
  IconButtonProps

export const ScrollableIconButton = ({
  direction,
  ...props
}: ScrollableIconButtonProps) => {
  const theme = useTheme()
  const { iconButton } = theme.components[`ScrollableTab`]?.styleOverrides || {}

  const backIcon = useMemo(
    () => getIcon(theme?.assets?.backIcon) || <ArrowBackIosRoundedIcon />,
    [theme]
  )

  const forwardIcon = useMemo(
    () => getIcon(theme?.assets?.nextIcon) || <ArrowForwardIosRoundedIcon />,
    [theme]
  )

  const arrowIcon = direction === "left" ? backIcon : forwardIcon
  return (
    <IconButton {...props} sx={iconButton}>
      {arrowIcon}
    </IconButton>
  )
}
